export const ruleMessage = {
  en: {
    required: 'Required',
    invalid_number_in_min_max: 'Number should be in {min} ~ {max}',
    invalid_email: 'Invalid e-mail',
  },
  zhHant: {
    required: '必填',
    invalid_number_in_min_max: '數字必須在 {min} ~ {max} 之間',
    invalid_email: '無效的email',
  },
  ja: {
    required: '必須',
    invalid_number_in_min_max: '数字は {min} ~ {max} の間でなければなりません',
    invalid_email: '無効なメール',
  },
  ko: {
    required: '필수',
    invalid_number_in_min_max: '숫자는 {min} ~ {max} 사이여야합니다',
    invalid_email: '잘못된 이메일입니다',
  },
};

// these function should be bind with item and $i18n, see i18n.js
export const validatedRules = {
  required: function (value) {
    return !!value || this.$i18n.t('required');
  },
  email: function (value) {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || this.$i18n.t('invalid_email');
  },
  numberInMinMax: function (value) {
    return (value >= this.item.min && value <= this.item.max) || this.$i18n.t('invalid_number_in_min_max', this.item);
  },
};
